import { Button } from '@bm-js/atlascloud-ui'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useTr } from '../utils/useTr'

interface UploadProgressProps {
  files: Array<{
    name: string
    percentage: number
  }>
  status: 'idle' | 'uploading' | 'error'
  onClose: () => void
}

export default function UploadProgress({
  files,
  status,
  onClose,
}: UploadProgressProps) {
  const { tr } = useTr()
  if (status === 'idle') return null
  if (status === 'uploading') {
    return (
      <div className='space-y-4'>
        <div className='space-y-2'>
          {files.map((file, index) => (
            <div key={index} className='relative pt-1'>
              <div className='flex mb-2 items-center justify-between'>
                <div>
                  <span className='text-xs font-semibold inline-block text-gray-900'>
                    {file.name}
                  </span>
                </div>
                <div className='text-right'>
                  <span className='text-xs font-semibold inline-block text-gray-900'>
                    {file.percentage}%
                  </span>
                </div>
              </div>
              <div className='overflow-hidden h-2 mb-4 text-xs flex rounded bg-primary-200'>
                <div
                  style={{ width: `${file.percentage}%` }}
                  className='shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-primary-400 transition-all duration-300'
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (status === 'error') {
    return (
      <div className='text-center'>
        <p className='text-lg text-red-600 mb-4'>
          {tr(TrKey.mediaUploadError)}
        </p>
        <Button onClick={onClose}>{tr(TrKey.close)}</Button>
      </div>
    )
  }
}
